import { Text } from '@chakra-ui/react'
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useAudioSettingsState } from '~/atoms/AudioSettingsState'
import { DropdownSelect } from '~/components/shared/Dropdown/DropdownSelect'

import { usePhoneSettingsStyles } from './componentStyles/PhoneSettings.styles'
import { DefaultSettingsWrapper, SubheadingSection } from './Shared'

export const AudioSettings = () => {
  const { t } = useTranslation()
  const styles = usePhoneSettingsStyles()
  const {
    permission: microphonePermission,
    output: {
      devices: outputs,
      preference: [selectedOutputDeviceId, setSelectedOutputDeviceId],
    },
    input: {
      devices: inputs,
      preference: [selectedInputDeviceId, setSelectedInputDeviceId],
    },
  } = useAudioSettingsState()

  const handleSelectAudioOutput = (deviceId: string) => {
    setSelectedOutputDeviceId(deviceId)
  }

  const handleSelectAudioInput = (deviceId: string) => {
    setSelectedInputDeviceId(deviceId)
  }

  const audioSettingsContent = useMemo(() => {
    if (microphonePermission === 'granted') {
      return (
        <>
          <Text {...styles.text2} color="fg.default">
            {t('audioSettings.selectSoundOutputSource')}
          </Text>
          <DropdownSelect
            items={outputs.map((output) => {
              return { content: output.label, value: output.deviceId }
            })}
            selectedValue={selectedOutputDeviceId}
            onSelect={handleSelectAudioOutput}
          />
          <Text {...styles.text2} color="fg.default">
            {t('audioSettings.selectInputSource')}
          </Text>
          <DropdownSelect
            items={inputs.map((input) => {
              return { content: input.label, value: input.deviceId }
            })}
            selectedValue={selectedInputDeviceId}
            onSelect={handleSelectAudioInput}
          />
        </>
      )
    }

    return (
      <Text {...styles.text2} color="fg.default">
        {t('audioSettings.toSelectAudioDevices')}
      </Text>
    )
  }, [
    microphonePermission,
    outputs,
    inputs,
    selectedInputDeviceId,
    selectedOutputDeviceId,
  ])

  return (
    <DefaultSettingsWrapper>
      <SubheadingSection>{audioSettingsContent}</SubheadingSection>
    </DefaultSettingsWrapper>
  )
}
